export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_16-c6264d7c78ce19bf2372d3c85134279f.jpg";